import { memo } from 'react';
import { attendanceStatusMeta } from './status';
import type { AttendanceStatus } from './types';

export const AttendanceStatusBadge = memo(function AttendanceStatusBadge({ status }: { status: AttendanceStatus }) {
  const m = attendanceStatusMeta(status);
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider ${m.bg} ${m.text} ${m.darkBg} ${m.darkText}`}>
      {m.label}
    </span>
  );
});
